import { Component, OnInit } from '@angular/core';
import { AuthService, ILocation } from '../auth.service';
import { Subject } from 'rxjs';
import { FavouriteService, IFavouriteItem } from '../favourite.service';
import { CLASS_ACTIVE, CLASS_EMPTY } from '../../../shared-third-party/consts';
import { MatDialog } from '@angular/material/dialog';
import { SimpleSearchComponent } from '../simple-search/simple-search.component';
import { filter, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-header-top',
  templateUrl: './header-top.component.html',
  styleUrl: './header-top.component.scss'
})
export class HeaderTopComponent implements OnInit {
  profileData = {
    username: '',
    userPhone: '',
  }
  favourites: IFavouriteItem[] = [];
  favouritesCount = 0;
  searchClass: string = CLASS_EMPTY;
  location: ILocation | null = null;
  locationCity: string = 'Москва';
  private unsubscribe$ = new Subject();

  constructor(public dialog: MatDialog, private authService: AuthService) {
  }

  ngOnInit(): void {
    this.authService.ndvUser$
      .pipe(
        takeUntil(this.unsubscribe$),
        filter((user) => !!user?.phone)
      )
      .subscribe((user) => {
        this.profileData.userPhone = user?.phone ?? '';
      });

    this.authService.location$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((location) => {
        this.locationCity = location?.cityNameI ?? 'Москва';
      });
  }

  getFavouriteCount() {
    return this.favouritesCount;
  }

  isNoFavorites(): string {
    return 'no-favorites';
  }

  getFavoritePath(): string {
    return '/favorites/'
  }

  getAddLink(): string {
    return this.isUserAuthorized() ? '/razmestit-object' : 'https://client.ndv.ru/cabinet/razmestit-object';
  }

  isUserAuthorized(): boolean {
    return false && !!this.profileData.userPhone;// Временно все неавторизованы
  }

  openDialog() {
    const dialogRef = this.dialog.open(SimpleSearchComponent);
    this.searchClass = CLASS_ACTIVE;
    dialogRef.afterClosed().subscribe(result => {});
  }

  getLocation(): void {
    this.authService.handleGeoPermission();
  }
}
